import { protectedAxiosInstance } from 'helpers/api-calls';

export const CreateDemoDataCall = (locationId) => {
  return protectedAxiosInstance.request({
    url: `api/customer/user_role/locations/${locationId}/create_demo_data`,
    method: 'PUT',
  });
};

export const DeleteDemoDataCall = (locationId) => {
  return protectedAxiosInstance.request({
    url: `api/customer/user_role/locations/${locationId}/delete_demo_data`,
    method: 'PUT',
  });
};
